import React from 'react';
import NavBase from './Nav';

const Nav = props => {
  return <NavBase {...props} />;
};

export default Nav;
